// Activity Log UI constants — mirrors MrCare's flow: module/action badge classes,
// module tabs (with grouped modules for count badges), per-tab action chips, a
// before→after diff engine, secret redaction, friendly field labels, and deep-links.

// Tailwind badge class pairs (bg + text). Dark-mode tints kept light-touch.
export const MODULE_BADGE: Record<string, string> = {
  AUTH: 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300',
  USER: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
  ROLE: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
  PROFILE: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  PASSWORD: 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300',
  RETAILER: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  FARMER: 'bg-lime-50 text-lime-700 dark:bg-lime-900/30 dark:text-lime-300',
  ORDER: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  ORDER_APPROVAL: 'bg-cyan-50 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
  SHIPMENT: 'bg-cyan-50 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
  INQUIRY: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  INVOICE: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  RETURN: 'bg-fuchsia-50 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-300',
  PAYMENT: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  PRODUCT: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
  PRODUCT_DETAILS: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
  SCHEME: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  COMMERCIAL_SCHEME: 'bg-teal-50 text-teal-700 dark:bg-teal-900/30 dark:text-teal-300',
  INVENTORY: 'bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
  STOCK_TRANSFER: 'bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
  PRODUCTION: 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300',
  WAREHOUSE: 'bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
  UOM: 'bg-surface-2 text-muted',
  TAX: 'bg-surface-2 text-muted',
  TRANSPORTER: 'bg-surface-2 text-muted',
  TERRITORY: 'bg-cyan-50 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
  TERRITORY_ASSIGNMENT: 'bg-cyan-50 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300',
  COMPLAINT: 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300',
  COMPLAINT_THREAD: 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300',
  EVENT: 'bg-fuchsia-50 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-300',
  VISIT: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  ROUTE: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  FFA: 'bg-lime-50 text-lime-700 dark:bg-lime-900/30 dark:text-lime-300',
  EXPENSE: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  EXPENSE_REPORT: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  ADVANCE_REQUEST: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
  WALLET: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  NOTIFICATION: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  NOTIFICATION_TEMPLATE: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  NOTIFICATION_PREFS: 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  WA_TEMPLATE: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  BANNER: 'bg-fuchsia-50 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-300',
  CONTENT: 'bg-fuchsia-50 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-300',
  IMPORT: 'bg-surface-2 text-muted',
  UPLOAD: 'bg-surface-2 text-muted',
  REPORT: 'bg-surface-2 text-muted',
  AI: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300',
};

const GREEN = 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300';
const BLUE = 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300';
const RED = 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300';
const AMBER = 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300';
const CYAN = 'bg-cyan-50 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300';
const PURPLE = 'bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300';
const GRAY = 'bg-surface-2 text-muted';

const ACTION_BADGE: Record<string, string> = {
  CREATED: GREEN, UPDATED: BLUE, DELETED: RED, DEACTIVATED: RED, CANCELLED: RED, REJECTED: RED,
  STATUS_CHANGED: AMBER, REOPENED: AMBER, REGULARIZED: AMBER, RETURNED: AMBER, REFUNDED: AMBER,
  APPROVED: GREEN, ACTIVATED: GREEN, DELIVERED: GREEN, PAYMENT_RECORDED: GREEN, PAYMENT_ALLOCATED: GREEN,
  CONVERTED: GREEN, TOPPED_UP: GREEN, CHECKED_IN: GREEN, RESTORED: GREEN,
  DRAFTED: AMBER, ARCHIVED: GRAY,
  SUBMITTED: CYAN, ASSIGNED: CYAN, REASSIGNED: CYAN, CLAIMED: CYAN, DISPATCHED: CYAN, UNASSIGNED: RED,
  CONTACTED: BLUE, SENT: BLUE, GENERATED: BLUE, ADJUSTED: AMBER, TRANSFERRED: AMBER,
  IMPORTED: PURPLE, EXPORTED: PURPLE, UPLOADED: PURPLE,
  LOGIN: GREEN, LOGOUT: GRAY, OTP_REQUESTED: BLUE, PASSWORD_CHANGED: RED, PASSWORD_RESET: RED,
  ADMIN_OVERRIDE_EDIT: 'bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300',
};
export const actionBadge = (a: string) => ACTION_BADGE[a] ?? GRAY;

// Module tabs — grouped so each tab can show a live count badge.
export interface TabDef { id: string; label: string; modules: string[] }
export const TABS: TabDef[] = [
  { id: 'all', label: 'All', modules: [] },
  { id: 'sales', label: 'Sales', modules: ['ORDER', 'ORDER_APPROVAL', 'SHIPMENT'] },
  { id: 'billing', label: 'Billing', modules: ['INVOICE', 'PAYMENT'] },
  { id: 'returns', label: 'Returns', modules: ['RETURN'] },
  { id: 'inventory', label: 'Inventory', modules: ['INVENTORY', 'STOCK_TRANSFER', 'PRODUCTION', 'WAREHOUSE'] },
  { id: 'catalog', label: 'Catalog', modules: ['PRODUCT', 'PRODUCT_DETAILS', 'SCHEME'] },
  { id: 'field', label: 'Field Ops', modules: ['COMPLAINT', 'COMPLAINT_THREAD', 'EVENT', 'VISIT', 'ROUTE', 'FFA'] },
  { id: 'money', label: 'Expenses', modules: ['EXPENSE', 'EXPENSE_REPORT', 'ADVANCE_REQUEST', 'WALLET'] },
  { id: 'people', label: 'People', modules: ['USER', 'RETAILER', 'FARMER', 'ROLE'] },
  { id: 'territory', label: 'Territory', modules: ['TERRITORY', 'TERRITORY_ASSIGNMENT'] },
  { id: 'inquiry', label: 'Inquiries', modules: ['INQUIRY'] },
  { id: 'comms', label: 'Comms', modules: ['NOTIFICATION', 'NOTIFICATION_TEMPLATE', 'NOTIFICATION_PREFS', 'WA_TEMPLATE', 'BANNER', 'CONTENT'] },
  { id: 'masters', label: 'Masters', modules: ['UOM', 'TAX', 'TRANSPORTER', 'COMMERCIAL_SCHEME'] },
  { id: 'auth', label: 'Auth', modules: ['AUTH', 'PROFILE', 'PASSWORD'] },
];

export const ACTION_CHIPS_BY_TAB: Record<string, string[]> = {
  sales: ['CREATED', 'STATUS_CHANGED', 'APPROVED', 'REJECTED', 'DISPATCHED', 'DELIVERED', 'CANCELLED'],
  billing: ['CREATED', 'GENERATED', 'PAYMENT_RECORDED', 'PAYMENT_ALLOCATED', 'UPDATED', 'DELETED'],
  returns: ['CREATED', 'APPROVED', 'REJECTED', 'CANCELLED'],
  inventory: ['CREATED', 'STATUS_CHANGED', 'ADJUSTED', 'TRANSFERRED', 'DELIVERED'],
  catalog: ['CREATED', 'UPDATED', 'DELETED'],
  field: ['CREATED', 'STATUS_CHANGED', 'ASSIGNED', 'CLOSED', 'REOPENED', 'SUBMITTED', 'APPROVED'],
  money: ['CREATED', 'SUBMITTED', 'APPROVED', 'REJECTED', 'PAYMENT_RECORDED', 'TOPPED_UP'],
  people: ['CREATED', 'UPDATED', 'DEACTIVATED', 'ASSIGNED'],
  territory: ['CREATED', 'UPDATED', 'ASSIGNED', 'REASSIGNED'],
  inquiry: ['CLAIMED', 'ASSIGNED', 'CONTACTED', 'CONVERTED', 'CLOSED', 'REOPENED'],
  comms: ['CREATED', 'UPDATED', 'DELETED', 'SENT', 'ACTIVATED', 'DEACTIVATED'],
  masters: ['CREATED', 'UPDATED', 'ACTIVATED', 'DEACTIVATED', 'ARCHIVED', 'DRAFTED', 'RESTORED', 'ASSIGNED', 'UNASSIGNED', 'DELETED'],
  auth: ['LOGIN', 'LOGOUT', 'OTP_REQUESTED', 'PASSWORD_CHANGED'],
};

// camel/snake → "Title Case", common acronyms upper-cased.
const ACRONYMS = new Set(['id', 'gst', 'gstin', 'hsn', 'utr', 'sku', 'mrp', 'moq', 'uom', 'sp', 'sh', 'kyc', 'pan', 'no', 'ip']);
export function humanLabel(key: string): string {
  return String(key)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((w) => (ACRONYMS.has(w.toLowerCase()) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(' ');
}

// UI-side redaction (defence in depth — backend already redacts on write).
const SENSITIVE_KEY = /pass|token|otp|secret|cvv|pin|auth|key|hash|credential/i;
const REDACTED = '[REDACTED]';
export function redactSensitive(value: any, depth = 0): any {
  if (value == null || depth > 6) return value;
  if (Array.isArray(value)) return value.map((v) => redactSensitive(v, depth + 1));
  if (typeof value === 'object') {
    if (value instanceof Date) return value;
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value)) out[k] = SENSITIVE_KEY.test(k) ? REDACTED : redactSensitive(v, depth + 1);
    return out;
  }
  return value;
}

export interface DiffRow { field: string; old: unknown; new: unknown }
/** Merge old + new into a field-by-field diff of CHANGED fields only. */
export function diffChangedFields(oldV: any, newV: any): DiffRow[] {
  const o = oldV && typeof oldV === 'object' && !Array.isArray(oldV) ? oldV : {};
  const n = newV && typeof newV === 'object' && !Array.isArray(newV) ? newV : {};
  const keys = Array.from(new Set([...Object.keys(o), ...Object.keys(n)]));
  const rows: DiffRow[] = [];
  for (const field of keys) {
    if (JSON.stringify(o[field]) !== JSON.stringify(n[field])) rows.push({ field, old: o[field], new: n[field] });
  }
  return rows;
}

// Deep-link from (module, reference_id) → admin route. null when not routable.
const ROUTES: Record<string, (id: string) => string> = {
  ORDER: (id) => `/orders/${id}`,
  ORDER_APPROVAL: (id) => `/orders/${id}`,
  SHIPMENT: (id) => `/orders/${id}`,
  INVOICE: (id) => `/billing/invoices/${id}`,
  RETURN: (id) => `/returns/${id}`,
  RETAILER: (id) => `/retailers/${id}`,
  FARMER: () => `/people?tab=farmers`,           // no farmer detail page — land on the list (like USER)
  COMPLAINT: (id) => `/complaints/${id}`,
  EVENT: (id) => `/events/${id}`,
  INQUIRY: () => `/inquiries`,
  PRODUCT: () => `/products`,                     // products open in a modal, not a route → list
  PRODUCT_DETAILS: () => `/products`,
  EXPENSE_REPORT: (id) => `/expense-reports/${id}`, // real path is /expense-reports/:id
  // ADVANCE_REQUEST intentionally omitted — no viewable route, so the "Open record" link hides itself.
  USER: () => `/people?tab=users`,
  ROLE: () => `/admin/roles`,
  COMMERCIAL_SCHEME: () => `/masters/commercial-terms`,
};
export function entityHref(module: string, refId?: string | null): string | null {
  if (!refId) return null;
  const fn = ROUTES[module];
  return fn ? fn(String(refId)) : null;
}

/**
 * The href for a whole log row — use this, not entityHref, wherever a row is opened.
 *
 * A row's `referenceId` is the record the entry was WRITTEN AGAINST, which is not always the record
 * a reader wants to see. A shipment log's reference is the shipment's own id, so `/orders/<that>`
 * opened a different, unrelated order. The server now says where such a row really belongs
 * (`linkModule` + `linkId`); rows without that pair — nearly all of them — are unchanged.
 */
export function logHref(log: {
  module: string; referenceId?: string | number | null;
  linkModule?: string | null; linkId?: string | number | null;
}): string | null {
  const mod = log.linkId != null ? (log.linkModule ?? log.module) : log.module;
  const id = log.linkId != null ? log.linkId : log.referenceId;
  return entityHref(mod, id == null ? null : String(id));
}
